import styled from 'styled-components';

import { colors, functions, zIndex } from '../../ui/variables';

const main = {
  padding: {
    iphone: 16,
  },
};

const closeModal = {
  size: {
    iphone: 20,
  },
};

export const ModalStyle = styled.div`
  ${zIndex.space};
  align-items: center;
  background-color: ${functions.rgba(colors.black, 0.5)};
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  padding: ${main.padding.iphone}px ${main.padding.iphone}px;
  position: fixed;
  top: 0;
  width: 100%;

  &.light-theme {
    .modal-box {
      .close-modal-wrapper {
        .close-modal {
          svg {
            fill: ${colors.veryDarkGrayishBlue};
          }
        }
      }
    }
  }

  &.dark-theme {
    .modal-box {
      .close-modal-wrapper {
        .close-modal {
          svg {
            fill: ${colors.mostlyWhite};
          }
        }
      }
    }
  }

  &.black-theme {
    .modal-box {
      background-color: ${colors.black};

      .close-modal-wrapper {
        .close-modal {
          svg {
            fill: ${colors.mostlyWhite};
          }
        }
      }
    }
  }

  &.with-shadow {
    .modal-box {
      box-shadow: 0px 5px 15px 0px ${functions.rgba(colors.black, 0.25)};
    }
  }

  &.fullscreen {
    padding: 0;

    .modal-box {
      border-radius: 0;
      height: 100vh;
      max-height: initial;
      max-width: initial;
      width: 100vw;

      .modal-content-wrapper {
        height: 100vh;
        max-height: initial;
        overflow: auto;
        width: 100%;
      }
    }
  }

  .modal-box {
    background-color: ${colors.mostlyWhite};
    border-radius: 12px;
    display: inline-block;
    max-height: calc(100vh - (2 * ${main.padding.iphone}px));
    max-width: 100%;
    overflow: hidden;
    position: relative;
    animation: fade-in 300ms 200ms;
    animation-fill-mode: both;

    .close-modal-wrapper {
      height: ${closeModal.size.iphone + main.padding.iphone}px;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;

      .close-modal {
        ${zIndex.sky};
        height: ${closeModal.size.iphone}px;
        position: absolute;
        right: ${main.padding.iphone}px;
        top: ${main.padding.iphone}px;
        width: ${closeModal.size.iphone}px;

        svg {
          width: ${closeModal.size.iphone / 2}px;
          display: inline-block;
        }
      }
    }

    .modal-content-wrapper {
      max-height: calc(
        100vh - ${closeModal.size.iphone + main.padding.iphone}px -
          (2 * ${main.padding.iphone}px)
      );
      overflow: auto;
      width: 100%;

      .modal-image-content,
      .modal-gallery-content {
        display: block;
        height: auto;
        width: auto;
      }

      .modal-gallery-content {
        display: flex;
        flex-wrap: wrap;

        .single-gallery-image {
          display: block;
          height: auto;
          width: auto;
        }
      }
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
